module.exports = __webpack_public_path__ + "static/media/klarna-sofort.b4f1352c.svg";